// `ParentChildForm/index.js` imports `getTransformErrors` from here and
// passes it as `transformErrors` on a `@rjsf/material-ui` <Form>. The file
// has been empty since the initial new-code/ import (4ec4ff6); CRA's webpack
// tolerated the missing export (yielded `undefined` at module load, would
// crash at runtime when the form opened), but Vite's Rollup rejects the
// build. Stubbing as a no-op preserves the prior runtime behavior:
// `transformErrors={undefined}` is rjsf's signal to use the default error
// formatter, which is what was effectively happening before.
export const getTransformErrors = () => undefined

// Same situation for `demoSchema` — imported by the parent index.js and
// passed as <Form schema={...}>. Empty object means "no validation
// schema" to rjsf, which matches the historical `undefined` behavior.
export const demoSchema = {}
